const UserStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  PENDING_UNPAUSE: 'PENDING_UNPAUSE',
  UNDEFINED: 'UNDEFINED',
  VERIFIED: 'VERIFIED',
});

export default UserStatus;
